import React, { useEffect } from 'react'
import './css/Navbar.css'
const Navbar = () => {
  useEffect(() => {
    const section = document.querySelector('.nav-list')
    const lists = document.querySelectorAll('.li-list')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          
          lists.forEach(i => {
            i.classList.add('animated')
          })
        }
      })
    })

    observer.observe(section)
  })

  return (
    <div className='nav-list'>
      <ul>
        <li className='li-list'>
          {' '}
          <a href='#home'>Home</a>{' '}
        </li>
        <li className='li-list'>
          {' '}
          <a href='#about'>About</a>{' '}
        </li>
        <li className='li-list'>
          {' '}
          <a href='#services'>Services</a>{' '}
        </li>
        <li className='li-list'>
          {' '}
          <a href='#projects'>Projects</a>{' '}
        </li>
        <li className='li-list'>
          {' '}
          <a href='#certifications'>Certifications</a>{' '}
        </li>
        <li className='li-list'>
          {' '}
          <a href='#contacts'>Contact Me</a>{' '}
        </li>
      </ul>
      <div className='title init'>
              <a target={'_blank'} href='mailto:lokyadav945275@gmail.com'>
                <i class='fa fa-envelope-o' aria-hidden='true'></i>
              </a>
              <a target={'_blank'} href='https://github.com/HamkerLokie'>
                <i class='fa fa-github' aria-hidden='true'></i>
              </a>
              <a target={'_blank'} href='https://github.com/HamkerLokie'>
                <i class='fa fa-linkedin' aria-hidden='true'></i>
              </a>
              <a target={'_blank'}  href='https://www.instagram.com/_maverick.o1/?igshid=YmMyMTA2M2Y%3D'>
                <i class='fa fa-instagram' aria-hidden='true'></i>
              </a>
              <a target={'_blank'}  href='https://twitter.com/Lokendr36634148'>
                <i class='fa fa-twitter' aria-hidden='true'></i>
              </a>
            </div>
    </div>
  )
}

export default Navbar
